<template>
  <van-popup
    class="ai-mobile-rename-popup"
    :close-on-click-overlay="!loading"
    :show="show"
    teleport="body"
    @opened="selectName"
    @update:show="emit('update:show', $event)"
  >
    <section :aria-labelledby="titleId" aria-modal="true" class="ai-mobile-rename" role="dialog">
      <div class="ai-mobile-rename__content">
        <h2 :id="titleId">重命名</h2>
        <div class="ai-mobile-rename__field">
          <input
            ref="inputRef"
            v-model="inputValue"
            aria-label="任务名称"
            :disabled="loading"
            enterkeyhint="done"
            type="text"
            @keydown.enter="handleEnter"
          />
          <button
            v-if="inputValue"
            aria-label="清空任务名称"
            class="ai-mobile-rename__clear"
            :disabled="loading"
            type="button"
            @click="clearName"
          >
            <i aria-hidden="true" class="icon-close-circle-fill t-iconfont"></i>
          </button>
        </div>
      </div>
      <div class="ai-mobile-rename__footer">
        <button :disabled="loading" type="button" @click="emit('update:show', false)">取消</button>
        <button
          class="ai-mobile-rename__confirm"
          :disabled="loading || !inputValue.trim()"
          type="button"
          @click="confirm"
        >
          <van-loading v-if="loading" color="#7a52f4" size="18px" />
          <span v-else>确定</span>
        </button>
      </div>
    </section>
  </van-popup>
</template>

<script setup>
import { ref, watch, useId } from 'vue'
import { Loading as VanLoading, Popup as VanPopup } from 'vant'

const props = defineProps({
  show: Boolean,
  loading: Boolean,
  name: { type: String, default: '' }
})
const emit = defineEmits(['update:show', 'confirm'])
const titleId = useId()
const inputRef = ref()
const inputValue = ref('')

watch(
  [() => props.show, () => props.name],
  () => {
    if (props.show) inputValue.value = props.name
  },
  { immediate: true }
)

const selectName = () => inputRef.value?.select()
const clearName = () => {
  inputValue.value = ''
  inputRef.value?.focus()
}
const confirm = () => {
  const name = inputValue.value.trim()
  if (!props.loading && name) emit('confirm', name)
}
const handleEnter = (event) => {
  if (event.isComposing) return
  event.preventDefault()
  confirm()
}
</script>

<style lang="scss" scoped>
.ai-mobile-rename-popup {
  width: min(311px, calc(100vw - 48px));
  overflow: hidden;
  border-radius: 16px;
}
.ai-mobile-rename {
  background: #ffffff;
  color: #323233;
  font-family: 'PingFang SC', sans-serif;

  &__content {
    padding: 24px;
    h2 {
      margin: 0;
      color: #242832;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      text-align: center;
    }
  }
  &__field {
    display: flex;
    align-items: center;
    height: 32px;
    margin-top: 8px;
    padding: 5px 11px;
    box-sizing: border-box;
    border: 1px solid #e5e8f5;
    border-radius: 8px;
    input {
      width: 100%;
      min-width: 0;
      flex: 1;
      height: 20px;
      padding: 0;
      border: 0;
      outline: none;
      background: transparent;
      color: #323233;
      font-family: inherit;
      font-size: 14px;
      line-height: 20px;
    }
  }
  &__clear {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    margin-left: 8px;
    padding: 0;
    border: 0;
    background: transparent;
    color: #969799;
    .t-iconfont {
      font-size: 16px;
      line-height: 16px;
    }
  }
  &__footer {
    display: flex;
    height: 48px;
    box-sizing: border-box;
    border-top: 0.5px solid #e5e8f5;
    button {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      padding: 0 12px;
      border: 0;
      background: #ffffff;
      color: #646d7d;
      font-family: inherit;
      font-size: 16px;
      line-height: 22px;
      & + button {
        border-left: 0.5px solid #e5e8f5;
      }
    }
    .ai-mobile-rename__confirm {
      color: #7a52f4;
      &:disabled {
        opacity: 0.5;
      }
    }
  }
}
</style>
